export const OPENED_ACTION = 'exitIntentLayerPicture/openedAction';
export const CLOSED_ACTION = 'exitIntentLayerPicture/closedAction';
export const CALLBACK_BUTTON_CLICKED_ACTION = 'exitIntentLayerPicture/callbackButtonClickedAction';
export const CHAT_BUTTON_CLICKED_ACTION = 'exitIntentLayerPicture/chatButtonClickedAction';
export const HOTLINE_BUTTON_CLICKED_ACTION = 'exitIntentLayerPicture/hotlineButtonClickedAction';
export const openedEvent = () => {
  return {
    event: 'find',
    event_action: 'exit_layer_pic_loaded',
    non_interaction: true
  };
};
export const closedEvent = () => {
  return {
    event: 'find',
    event_action: 'exit_layer_pic_closed',
    non_interaction: false
  };
};
export const callbackButtonClickedEvent = () => {
  return {
    event: 'find',
    event_action: 'exit_layer_pic_callback_click',
    non_interaction: false
  };
};
export const chatButtonClickedEvent = () => {
  return {
    event: 'find',
    event_action: 'exit_layer_pic_chat_click',
    non_interaction: false
  };
};
export const hotlineButtonClickedEvent = () => {
  return {
    event: 'find',
    event_action: 'exit_layer_pic_hotline_click',
    non_interaction: false
  };
};
export const eventsMap = {
  [OPENED_ACTION]: openedEvent,
  [CLOSED_ACTION]: closedEvent,
  [CALLBACK_BUTTON_CLICKED_ACTION]: callbackButtonClickedEvent,
  [CHAT_BUTTON_CLICKED_ACTION]: chatButtonClickedEvent,
  [HOTLINE_BUTTON_CLICKED_ACTION]: hotlineButtonClickedEvent
};